var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-controller"},[(_vm.popupView)?_c(_vm.popupView,_vm._b({ref:"popupView",tag:"component",on:{"close":function($event){return _vm.close()}},nativeOn:{"click":function($event){$event.stopPropagation();}}},'component',_vm.props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }